// extracted by mini-css-extract-plugin
export default {"external":"aDPX5d","deprecatedBorderRadius":"bDPX5d","hasAnimation":"cDPX5d","container":"dDPX5d"};